module.exports = __webpack_public_path__ + "static/img/icon_sousuo@2x.c9dffab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trademark/brand/icon_sousuo@2x.png
// module id = jSAs
// module chunks = 0